// extracted by mini-css-extract-plugin
export default {"card":"AumChartWidget_card__3UAHZ","chartArea":"AumChartWidget_chartArea__z6qU2","summary":"AumChartWidget_summary__VdRkw"};